import Api from '@/service/api';
import * as restorePasswordHelper from '@/helpers/restore-password';

import Input from '@/components/Form/Input/index.vue';
import PasswordRating from '@/components/Form/PasswordRating/PasswordRating.vue';

import { WEAK_PASSWORD, STRONG_PASSWORD } from '@/constants/constants';


export default {
  name: 'PasswordChange',

  components: {
    PasswordRating,
    Input,
  },

  watch: {
    password() {
      this.isDescriptionHintsOpen = false;
    },
  },

  methods: {
    toggleDescriptionHintsState(state) {
      this.isDescriptionHintsOpen = state === undefined ? !this.isDescriptionHintsOpen : state;
    },

    checkPasswordRating(rating) {
      this.isCanChange = rating !== WEAK_PASSWORD;
      this.passwordRating = rating;
      this.isDescriptionHintsOpen = rating !== STRONG_PASSWORD;
    },

    onCancel() {
      this.$router.push('/sign_in');
    },

    async onChangePassword() {
      if (!this.validate()) {
        return;
      }

      this.isCanChange = false;
      try {
        const data = {
          login: this.login,
          new_password: this.password,
        };

        data[this.codeType] = this.code;

        await Api.post({
          url: 'password-restoration/change-password',
          data,
        });
      } catch (error) {
        this.isCanChange = true;
        this.isError = true;
        this.errorCode = error.code;

        return;
      }

      restorePasswordHelper.clearData();

      if (this.$store.getters.isNeedReturnToOAuth2) {
        this.$router.push('/oauth2/authorize');

        return;
      }

      this.$router.push('/password/success');
    },

    validate() {
      if (!this.$refs.password.validate() || this.passwordRating === WEAK_PASSWORD) {
        this.validated = false;
      }

      return this.validated;
    },

    fieldsChanged() {
      this.validated = true;
      this.isError = false;
    },
  },

  created() {
    const localData = restorePasswordHelper.getLast();
    this.code = restorePasswordHelper.getCode();
    this.codeType = restorePasswordHelper.getType();

    if (!this.code || !localData) {
      this.$router.push('/password/restoration');
      return;
    }

    this.login = localData.login;
  },

  data() {
    return {
      password: null,
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      isDescriptionHintsOpen: false,
      isCanChange: false,
    };
  },
};
